import { MenuListInput } from './menu-list-input.model';


export class UserGroupAddInput implements IUserGroupAddInput {
    /** The user group name with 255 character limit */
    userGroupName!: string;
    /** The auto-generated id of the application module master */
    applicationModuleId!: number;
    /** The auto-generated id of the user type master */
    userTypeId!: number;
    /** The auto-generated id of the company details master */
    companyDetailsId!: number;
    menuList!: MenuListInput[];

    constructor(data?: IUserGroupAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupName = _data["userGroupName"];
            this.applicationModuleId = _data["applicationModuleId"];
            this.userTypeId = _data["userTypeId"];
            this.companyDetailsId = _data["companyDetailsId"];
            if (Array.isArray(_data["menuList"])) {
                this.menuList = [] as any;
                for (let item of _data["menuList"])
                    this.menuList!.push(MenuListInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserGroupAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGroupName"] = this.userGroupName;
        data["applicationModuleId"] = this.applicationModuleId;
        data["userTypeId"] = this.userTypeId;
        data["companyDetailsId"] = this.companyDetailsId;
        if (Array.isArray(this.menuList)) {
            data["menuList"] = [];
            for (let item of this.menuList)
                data["menuList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUserGroupAddInput {
    /** The user group name with 255 character limit */
    userGroupName: string;
    /** The auto-generated id of the application module master */
    applicationModuleId: number;
    /** The auto-generated id of the user type master */
    userTypeId: number;
    /** The auto-generated id of the company details master */
    companyDetailsId: number;
    menuList: MenuListInput[];
}

